const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '基本信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/gt-jy-zhaobiao/api/refund/apply/getBdInfo.do`, {
                bdGuid: this.form.bdGuid,
                orderType: 'ptfwf',
            }, { showLoading: true }).then((res) => {
                this.config[1].options.data = {
                    '标段/包名称': res.data.bdName,
                    '标段/包编号': res.data.bdBh,
                    '项目类型': getProjectTypeName(res.data.zbxmlx),
                    '采购方式': getPurchaseTypeName(res.data.cgFangShi),
                    '项目经理': res.data.xmjlName,
                    '联系电话': res.data.xmphone,
                }
            })
        },
        pass() {
            this.commit()
        },
        fail(opinion) {
            this.commit({
                opValue: '2', // 不通过
                opinion: opinion,
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
